import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Chip } from "@air/primitive-chip";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const PopularTags = /*#__PURE__*/ memo((param)=>{
    let { className, onTagClick, tags } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("flex flex-col gap-2", className),
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "text-10 font-bold uppercase tracking-wider text-grey-9",
                children: "Popular Tags"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-2",
                children: tags.map((tag)=>/*#__PURE__*/ _jsx(Chip, {
                        asChild: true,
                        onClick: ()=>onTagClick(tag),
                        shape: "rounded",
                        size: "medium",
                        children: /*#__PURE__*/ _jsx("button", {
                            children: tag.label
                        })
                    }, tag.id))
            })
        ]
    });
});
PopularTags.displayName = "PopularTags";
